/*
 * Delete-intake-form action (edit mode only; rendered when onDeleteIntakeForm is provided).
 *
 * SCSS → Tailwind mapping (ceiv-delete-section):
 *   display:flex / padding:8px 0 → flex py-sp-1
 */
import { Button, TrashIcon } from '@quickmd-llc/design-system'

type Props = {
  onDeleteIntakeForm: () => void
}

export function IntakeDeleteSection({ onDeleteIntakeForm }: Props) {
  return (
    <div className='flex py-sp-1'>
      <Button priority='tertiary' theme='danger' size='s' onClick={onDeleteIntakeForm}>
        <TrashIcon iconSize='s' />
        Delete intake form
      </Button>
    </div>
  )
}
